import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import pegawaiSubkonService from "../../services/pegawaiSubkonService";
import Cookies from "js-cookie";

export const initialState = {
    loading_pegawai_subkon: false,
    data_pegawai_subkon: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataPegawaiSubkon = createAsyncThunk('pegawai_subkon/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiSubkonService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const getaDataImport = createAsyncThunk('pegawai_subkon/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiSubkonService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('pegawai_subkon/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiSubkonService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('pegawai_subkon/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiSubkonService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const pegawaiSubkonSlice = createSlice({
    name: 'pegawai_subkon',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pegawai_subkon = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPegawaiSubkon.fulfilled, (state, action) => {
                state.loading_pegawai_subkon = false
                state.data_pegawai_subkon = action.payload??[]
            })
            .addCase(getDataPegawaiSubkon.pending, (state) => {
                state.loading_pegawai_subkon = true
            })
            .addCase(getDataPegawaiSubkon.rejected, (state, action) => {
                state.loading_pegawai_subkon = false
                state.data_pegawai_subkon = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_pegawai_subkon = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_pegawai_subkon = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_pegawai_subkon = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = pegawaiSubkonSlice.actions

export default pegawaiSubkonSlice.reducer
